var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2291 6.11452C12.2291 9.49148 9.49149 12.229 6.11454 12.229C2.73758 12.229 1.04717e-05 9.49148 1.04717e-05 6.11452C1.04717e-05 2.73757 2.73758 0 6.11454 0C9.49149 0 12.2291 2.73757 12.2291 6.11452Z",
    fill: "#C0BFC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7905 2.77933C22.7905 4.31431 21.5462 5.55866 20.0112 5.55866C18.4762 5.55866 17.2319 4.31431 17.2319 2.77933C17.2319 1.24435 18.4762 0 20.0112 0C21.5462 0 22.7905 1.24435 22.7905 2.77933Z",
    fill: "#C0BFC7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3964 6.78766C19.9457 7.06214 20.1684 7.72988 19.8939 8.27911L16.461 15.1483L14.8036 13.4909L17.905 7.28513C18.1795 6.73591 18.8472 6.51318 19.3964 6.78766Z",
    fill: "#C0BFC7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0326 15.5686H7.66404C6.7156 15.5686 5.81202 15.9724 5.17934 16.679L0.283511 22.1467C-0.126067 22.6041 -0.0872841 23.3069 0.370135 23.7165C0.827554 24.1261 1.53039 24.0873 1.93997 23.6299L6.8358 18.1622C7.0467 17.9266 7.34789 17.792 7.66404 17.792H14.2561L12.0326 15.5686Z",
    fill: "#C0BFC7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3731 18.4017L16.8608 19.405C16.6708 19.777 16.2884 20.0112 15.8707 20.0112H8.89386C8.27987 20.0112 7.78213 20.5089 7.78213 21.1229C7.78213 21.7369 8.27987 22.2346 8.89386 22.2346H15.8707C17.1238 22.2346 18.2711 21.5322 18.841 20.4162L24.8924 8.56565C25.1716 8.01882 24.9547 7.34917 24.4078 7.06994C23.861 6.79071 23.1914 7.00764 22.9121 7.55446L17.8028 17.5602C17.7434 17.866 17.6002 18.1588 17.3731 18.4017Z",
    fill: "#C0BFC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/Security.c4dac8a3889da12f4e3b1aee94be38ae.svg";
export { ForwardRef as ReactComponent };